/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/exhaustive-deps */
import { debounce, isNil } from 'lodash';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import NumberFormat from 'react-number-format';
import { areEqualFields, onKeyDown } from 'utils/form';
import s from './SliderWithTooltip.module.scss';

const config = {
  en: {
    thousandSeparator: ',',
    decimalSeparator: '.',
  },
  de: {
    thousandSeparator: '.',
    decimalSeparator: ',',
  },
};

const Input = ({
  form,
  name,
  min,
  max,
  units,
  value,
  setValue,
  sliderValue,
  forciblyReplaceInputValue = false,
  thousandSeparator,
  sideEffectOnChange,
  changeableStep,
  setChangeableStep,
  fieldWrapperRef,
}) => {
  const { locale } = useIntl();
  const inputRef = useRef();
  const [, forceRerender] = useState(false);
  const [shouldInputValueBeEqualsSlider, setInputValueBeEqualsSlider] = useState(false);

  useEffect(() => {
    if (shouldInputValueBeEqualsSlider && sliderValue !== value) {
      setValue(sliderValue);
    }
  }, [setValue, shouldInputValueBeEqualsSlider, sliderValue, value]);

  const handleChange = useCallback(
    debounce((_values) => {
      setInputValueBeEqualsSlider(false);
      let v;
      if (isNil(_values.floatValue)) {
        v = null;
      } else {
        v = _values.floatValue > max ? max : _values.floatValue;
      }
      setValue(v);

      if (typeof sideEffectOnChange === 'function') sideEffectOnChange(v);
      if (Number.isFinite(v) && v >= min && v <= max) form.setFieldValue(name, v);

      forceRerender((b) => !b);
    }, 500),
    [max, setValue],
  );

  const handleFocus = useCallback(
    (e) => {
      e.target.focus();
      if (changeableStep) {
        setChangeableStep(false);
      }
      if (forciblyReplaceInputValue) {
        setInputValueBeEqualsSlider(true);
      }
    },
    [changeableStep, setChangeableStep],
  );

  const handleBlur = useCallback(() => {
    form.setFieldTouched(name, true);
    if (forciblyReplaceInputValue) {
      setInputValueBeEqualsSlider(true);
    }
  }, [forciblyReplaceInputValue, form, name]);

  const handleKeyDown = useCallback(
    (e) => {
      onKeyDown(e, fieldWrapperRef);
    },
    [fieldWrapperRef],
  );

  return (
    <div className={s.inputWrapper}>
      <label htmlFor={`${name}-number-input`}>
        <NumberFormat
          ref={inputRef}
          max={max}
          value={value}
          allowNegative={false}
          allowLeadingZeros={false}
          allowEmptyFormatting={false}
          {...(!isNil(thousandSeparator) ? { thousandSeparator } : config[locale])}
          name={`${name}-number-input`}
          autoComplete="off"
          id={`${name}-number-input`}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}
          className={s.numberInput}
          type="text"
          onValueChange={handleChange}
          onBlur={handleBlur}
        />
      </label>
      <div className={s.units}>{units}</div>
    </div>
  );
};

export default memo(Input, (prevProps, nextProps) => areEqualFields(prevProps, nextProps, ['value', 'sliderValue']));
